import type { ModelClientSubscription } from '@app/api/Subscriptions';

/** Услуга абонемента клиента и сколько её единиц свободно */
export interface ClientSubscriptionServiceView {
  /** ID услуги из справочника услуг */
  clientServiceId: number;
  name: string;
  available: number;
}

/** Абонемент клиента для окна записи */
export interface ClientSubscriptionView {
  clientSubscriptionId: number;
  name: string;
  /** Сколько услуг свободно на абонементе */
  available: number;
  services: ClientSubscriptionServiceView[];
  /** Остаток по услугам: «Пилинг — 3, Массаж — 2» */
  servicesLabel: string;
}

// GetClientSubscriptions отдаёт каждую свободную единицу услуги отдельной
// строкой (нюанс 2 ТЗ us/11427): остаток услуги — число её строк, так же
// UpdateRecord считает свободные единицы. Строки абонемента группируем по Id
// услуги. Абонементы не сливаем: у каждого свой ClientSubscriptionId, даже
// если услуги совпадают.
export const groupClientSubscriptions = (
  subscriptions: ModelClientSubscription[] | undefined
): ClientSubscriptionView[] =>
  (subscriptions ?? [])
    .map(({ ClientSubscriptionId, SubscriptionName, SubscriptionServices }) => {
      const servicesById = new Map<number, ClientSubscriptionServiceView>();

      (SubscriptionServices ?? []).forEach(({ Id, Name }) => {
        const current = servicesById.get(Id);

        servicesById.set(Id, {
          clientServiceId: Id,
          name: current?.name || Name || 'Услуга без названия',
          available: (current?.available ?? 0) + 1,
        });
      });

      const services = [...servicesById.values()];

      return {
        clientSubscriptionId: ClientSubscriptionId,
        name: SubscriptionName ?? '',
        available: services.reduce((sum, { available }) => sum + available, 0),
        services,
        servicesLabel: services
          .map(({ name, available }) => `${name} — ${available}`)
          .join(', '),
      };
    })
    .filter(({ available }) => available > 0);
